import { Link, LinkProps } from "react-router-dom";
import { useLocalizedLink } from "@/hooks/useLocalizedLink";
import { ReactNode } from "react";

interface LocalizedLinkProps extends Omit<LinkProps, 'to'> {
  to: string;
  children: ReactNode;
}

/**
 * Wrapper around react-router Link that automatically translates URLs
 * Use this instead of Link for internal navigation
 * 
 * @example
 * <LocalizedLink to="/practice-areas/immigration-services">
 *   Immigration Services
 * </LocalizedLink>
 */
export const LocalizedLink = ({ to, children, ...props }: LocalizedLinkProps) => {
  const localizedPath = useLocalizedLink(to);
  
  return (
    <Link to={localizedPath} {...props}>
      {children}
    </Link>
  );
};
